import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from "react-ga4";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppRouter from './Routes/routes';
import Service from './service';
const root = ReactDOM.createRoot(document.getElementById('root'));

const TRACKING_ID = "G-GX3Q2EVCK6"; 
ReactGA.initialize(TRACKING_ID);

root.render(
   //<React.StrictMode>
    <AppRouter />
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
